import React from "react";
import { Instagram, Facebook, ShoppingBag } from "lucide-react";
import { useLang } from "../../i18n";
import { MaskLine, Reveal } from "../../lib/motion.jsx";

const SHOP_IMG = "https://static.prod-images.emergentagent.com/jobs/66efb70c-9962-4996-a00f-28e239b83f81/images/4d94dea28948d7c2bd1df78a51676bf8a21849a9f5563bd9c9925c1f66d9332d.jpeg";

export default function FcShop() {
  const { t } = useLang();
  return (
    <div className="fc-theme" data-testid="fc-shop-page">
      <section className="relative h-[70vh] min-h-[500px] overflow-hidden">
        <img src={SHOP_IMG} alt="Clubshop" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-[#0A0A0A]/20" />
        <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-end px-6 pb-14">
          <span className="mb-3 flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-[#CCFF00]">
            <ShoppingBag size={14} /> FC Inkad
          </span>
          <h1 className="font-anton text-6xl md:text-8xl uppercase leading-none">
            <MaskLine>{t("nav_clubshop")}</MaskLine>
          </h1>
          <div className="mt-6 inline-flex w-fit items-center gap-2 border border-[#CCFF00]/50 bg-[#CCFF00]/10 px-4 py-2" data-testid="fc-shop-soon-badge">
            <span className="h-2 w-2 rounded-full bg-[#CCFF00] animate-pulse" />
            <span className="text-sm font-extrabold uppercase tracking-wide text-[#CCFF00]">{t("shopSoonBadge")}</span>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-3xl px-6 py-16 text-center">
        <Reveal>
          <p className="text-lg text-white/70" data-testid="fc-shop-soon-text">{t("shopSoonText")}</p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <a href="https://www.instagram.com/inkad_diegem/" target="_blank" rel="noreferrer" className="rounded-sm border border-white/15 p-3 text-white/70 hover:text-[#CCFF00] hover:border-[#CCFF00] transition-colors" aria-label="Instagram"><Instagram size={20} /></a>
            <a href="https://www.facebook.com/fcinkaddiegem/" target="_blank" rel="noreferrer" className="rounded-sm border border-white/15 p-3 text-white/70 hover:text-[#CCFF00] hover:border-[#CCFF00] transition-colors" aria-label="Facebook"><Facebook size={20} /></a>
          </div>
          <p className="mt-4 text-xs uppercase tracking-widest text-white/30">{t("shopFollow")}</p>
        </Reveal>
      </div>
    </div>
  );
}
